<template>
  <div class="card">
    <div class="card-content" v-if="product">
      <div class="author">
        <img class="avatar border-white" :src="product.picture ? product.picture.url : 'static/img/default-product.png'" alt="...">
        <h4 class="title">{{ product.name }}
        </h4>
      </div>
      <p class="description text-center">
        {{product.description}}
      </p>
    </div>
    <hr>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex'

  export default {
    props: {
      company: {
        type: Object,
        required: true
      },
      product: {
        type: Object,
        required: true
      }
    }
  }

</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/Product/Card.vue